import type { FC } from 'react';

import useRenderBlueskyEmbeds from '~/hooks/useRenderBlueskyEmbeds';
import useRenderStocktwitsEmbeds from '~/hooks/useRenderStocktwitsEmbeds';
import useRenderTiktokEmbeds from '~/hooks/useRenderTiktokEmbeds';
import useRenderTwitterEmbeds from '~/hooks/useRenderTwitterEmbeds';

interface TransformedHtmlProps {
  postRef?: any;
  html: string;
  slug: string;
  update?: boolean;
}

const TransformedHtmlCore: FC<TransformedHtmlProps> = ({ html, slug, update = true }) => {
  useRenderTiktokEmbeds(slug, update);
  useRenderTwitterEmbeds(slug, update);
  useRenderBlueskyEmbeds(slug, update);
  useRenderStocktwitsEmbeds(slug, update);

  return <div suppressHydrationWarning dangerouslySetInnerHTML={{ __html: html }} />;
};

export default TransformedHtmlCore;
